import { GetAllHealthPlans } from 'domain/usecases/patient/get-all-health-plans'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteGetAllHealthPlans implements GetAllHealthPlans {
  constructor(private readonly patientNewRepository: PatientNewRepository) {}

  get(): Promise<GetAllHealthPlans.Model> {
    return this.patientNewRepository.getAllHealthPlans()
  }
}
